const SET_LOGIN = (state, value) => {
  state.isLogin = value;
};

const SET_CONCURRENT_LOGIN = (state, value) => {
  state.isConcurrentLogin = value;
};

const SET_SMT_LOGIN = (state, value) => {
  state.isSmtLogin = value;
};

const SET_TOKEN_EXPIRATION = (state, value) => {
  state.isTokenExpiration = value;
};

const SET_LOGIN_USER_INFO = (state, userInfo) => {
  state.loginUser = userInfo;
};

const UPDATE_CURRENT_COMPANY = (state, cmpn) => {
  state.loginUser.curCmpnId = cmpn.cmpnId
  state.loginUser.curCmpnNm = cmpn.cmpnNm
}

const setAccessDenied = (state, accessDenied) => {
  state.accessAuthority.accessDenied = accessDenied;
};

const setOtpDenied = (state, otpDenied) => {
  state.accessAuthority.otpDenied = otpDenied;
};

const setAllowedIpNull = (state, allowedIpNull) => {
  state.accessAuthority.allowedIpNull = allowedIpNull;
};

const setAllowedIpDenied = (state, allowedIpDenied) => {
  state.accessAuthority.allowedIpDenied = allowedIpDenied;
};

const setLoginDeniedConCurrent = (state, loginDeniedConCurrent) => {
  state.accessAuthority.loginDeniedConCurrent = loginDeniedConCurrent;
};

const setComplianceHistory = (state, info) => {
  state.browserHistory.compliance = info;
};

const setAssessmentStatus = (state, status) => {
  state.browserHistory.compliance.isOnInspection = status;
}

const setPolicyHistory = (state, info) => {
  state.browserHistory.policy = info;
};

const setAuditHistory = (state, info) => {
  state.browserHistory.audit = info;
};

export default {
  SET_LOGIN,
  SET_CONCURRENT_LOGIN,
  SET_SMT_LOGIN,
  SET_TOKEN_EXPIRATION,
  SET_LOGIN_USER_INFO,
  UPDATE_CURRENT_COMPANY,
  setAccessDenied,
  setOtpDenied,
  setAllowedIpNull,
  setAllowedIpDenied,
  setLoginDeniedConCurrent,
  setComplianceHistory,
  setPolicyHistory,
  setAuditHistory,
  setAssessmentStatus
};



// WEBPACK FOOTER //
// ./src/store/modules/user/mutations.js